/* M2L Digital Studios - service tier modal.
   Cart mode  (product linked): collects project details → /cart/add.js
   Quote mode (no product):     collects project details → /contact (AJAX) */
(function () {
  'use strict';

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var REDESIGN_RE = /redesign/i;

  var CART_INTRO  = 'Tell us about your project, your answers attach directly to the order so we can get started immediately.';
  var QUOTE_INTRO = "Tell us about your project and we'll put together a quote within 24 hours.";
  var SUCCESS_MSG = "Message sent, we'll be in touch soon.";

  /* ---- refs ---- */
  var modal, form, variantInput, tierEl, priceEl, submitBtn, hint, errorEl, introEl;
  var purposeSelect, existingUrlField, existingUrlInput;
  var requiredFields = [];
  var currentMode   = 'cart';

  /* ---- helpers ---- */
  function isValid(field) {
    var v = field.value.trim();
    if (!v) return false;
    if (field.type === 'email') return EMAIL_RE.test(v);
    return true;
  }

  function buildRequiredFields() {
    requiredFields = Array.prototype.slice.call(form.querySelectorAll('[data-required]'));
    if (existingUrlInput && existingUrlInput.required) {
      if (requiredFields.indexOf(existingUrlInput) === -1) requiredFields.push(existingUrlInput);
    }
  }

  function updateSubmitState() {
    if (!submitBtn) return;
    buildRequiredFields();
    var ok = requiredFields.every(isValid);
    submitBtn.disabled = !ok;
    if (hint) hint.classList.toggle('pricing-form-hint--hidden', ok);
  }

  /* ---- conditional URL field ---- */
  function toggleUrlField() {
    if (!existingUrlField || !existingUrlInput) return;
    var show = REDESIGN_RE.test(purposeSelect.value);
    existingUrlField.classList.toggle('pf-field--visible', show);
    existingUrlField.setAttribute('aria-hidden', show ? 'false' : 'true');
    existingUrlInput.required = show;
    if (!show) { existingUrlInput.value = ''; existingUrlField.classList.remove('has-error'); }
    updateSubmitState();
  }

  /* ---- open / close ---- */
  function openModal(tier, price, variantId, mode) {
    if (!modal) return;
    currentMode = mode || (variantId ? 'cart' : 'quote');

    if (tierEl)  tierEl.textContent  = tier;
    if (priceEl) priceEl.textContent = price || '';
    if (variantInput) variantInput.value = variantId || '';

    var labelEl = submitBtn ? submitBtn.querySelector('.btn-label') : null;
    if (labelEl) labelEl.textContent = currentMode === 'cart' ? 'Secure My Spot' : 'Send My Details';
    if (introEl) introEl.textContent = currentMode === 'cart' ? CART_INTRO : QUOTE_INTRO;

    resetForm();

    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setTimeout(function () {
      var first = form ? form.querySelector('input, select, textarea') : null;
      if (first) first.focus();
    }, 80);
  }

  function closeModal() {
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function resetForm() {
    if (form) { form.reset(); form.style.display = ''; }
    if (variantInput) variantInput.value = '';
    if (errorEl) errorEl.textContent = '';
    if (existingUrlField) {
      existingUrlField.classList.remove('pf-field--visible');
      existingUrlField.setAttribute('aria-hidden', 'true');
      if (existingUrlInput) existingUrlInput.required = false;
    }
    if (submitBtn) { submitBtn.style.display = ''; submitBtn.classList.remove('is-loading'); }
    if (hint) { hint.style.display = ''; hint.classList.remove('pricing-form-hint--hidden'); }
    if (introEl) introEl.style.display = '';
    updateSubmitState();
  }

  /* ---- cart submit ---- */
  function submitToCart() {
    var routes  = window.M2L_ROUTES || { cartAddUrl: '/cart/add.js' };
    var labelEl = submitBtn ? submitBtn.querySelector('.btn-label') : null;
    var origLabel = labelEl ? labelEl.textContent : '';

    if (errorEl) errorEl.textContent = '';
    if (submitBtn) { submitBtn.disabled = true; submitBtn.classList.add('is-loading'); }
    if (labelEl) labelEl.textContent = 'Adding…';

    fetch(routes.cartAddUrl, {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (res) { return res.json().then(function (d) { return { ok: res.ok, data: d }; }); })
      .then(function (r) {
        if (!r.ok) throw new Error(r.data && r.data.description ? r.data.description : 'Could not add to cart. Please try again.');
        closeModal();
        if (window.M2LCart) window.M2LCart.refresh().then(function () { window.M2LCart.open(); });
      })
      .catch(function (err) {
        if (errorEl) errorEl.textContent = err.message;
        if (submitBtn) { submitBtn.disabled = false; submitBtn.classList.remove('is-loading'); }
        if (labelEl) labelEl.textContent = origLabel;
      });
  }

  /* ---- quote submit (contact form) ---- */
  function submitQuote() {
    var tokenForm  = document.getElementById('m2lQuoteTokenForm');
    var authToken  = tokenForm ? tokenForm.querySelector('[name="authenticity_token"]') : null;
    var labelEl    = submitBtn ? submitBtn.querySelector('.btn-label') : null;
    var origLabel  = labelEl ? labelEl.textContent : '';

    if (errorEl) errorEl.textContent = '';
    if (submitBtn) { submitBtn.disabled = true; submitBtn.classList.add('is-loading'); }
    if (labelEl) labelEl.textContent = 'Sending…';

    var g = function (id) { var el = form.querySelector('#' + id); return el ? el.value.trim() : ''; };

    var lines = ['Quote request - ' + (tierEl ? tierEl.textContent : '') + ' tier'];
    var purpose = g('smPurpose');
    if (purpose)              lines.push('Website purpose: ' + purpose);
    var existingUrl = g('smExistingUrl');
    if (existingUrl)          lines.push('Current website: ' + existingUrl);
    var pages = g('smPages');
    if (pages)                lines.push('Pages needed: ' + pages);
    var notes = g('smNotes');
    if (notes)                lines.push('Specifics: ' + notes);
    var colors = g('smBrandColors');
    if (colors)               lines.push('Brand colors: ' + colors);
    var domain = g('smDomain');
    if (domain)               lines.push('Has domain: ' + domain);
    var logo = g('smLogo');
    if (logo)                 lines.push('Logo assets: ' + logo);

    var fd = new FormData();
    fd.append('form_type', 'contact');
    fd.append('utf8', '✓');
    if (authToken) fd.append('authenticity_token', authToken.value);
    fd.append('contact[name]',  g('smBiz') || 'Quote request');
    fd.append('contact[email]', g('smEmail'));
    fd.append('contact[body]',  lines.join('\n'));

    fetch('/contact', { method: 'POST', body: fd })
      .then(function (res) {
        if (res.ok || res.redirected) {
          if (form)    form.style.display    = 'none';
          if (submitBtn) submitBtn.style.display = 'none';
          if (hint)    hint.style.display    = 'none';
          if (introEl) introEl.textContent   = SUCCESS_MSG;
        } else {
          throw new Error('Could not send your message. Please try again.');
        }
      })
      .catch(function (err) {
        if (errorEl) errorEl.textContent = err.message;
        if (submitBtn) { submitBtn.disabled = false; submitBtn.classList.remove('is-loading'); }
        if (labelEl) labelEl.textContent = origLabel;
      });
  }

  /* ---- GSAP entrance ---- */
  function animateModalIn() {
    if (typeof gsap === 'undefined') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var panel  = modal.querySelector('.service-modal-panel');
    var fields = panel ? Array.prototype.slice.call(panel.querySelectorAll('.pf-field, .pricing-form-footer')) : [];
    if (!panel) return;
    gsap.fromTo(panel,  { y: 32, opacity: 0 }, { y: 0, opacity: 1, duration: 0.45, ease: 'power3.out' });
    if (fields.length) gsap.fromTo(fields, { y: 14, opacity: 0 }, { y: 0, opacity: 1, duration: 0.4, stagger: 0.055, ease: 'power2.out', delay: 0.1 });
  }

  /* ---- boot ---- */
  document.addEventListener('DOMContentLoaded', function () {
    modal     = document.getElementById('m2lServiceModal');
    if (!modal) return;

    form          = modal.querySelector('[data-service-modal-form]');
    variantInput  = modal.querySelector('#smVariantId');
    tierEl        = modal.querySelector('.service-modal-tier');
    priceEl       = modal.querySelector('.service-modal-price');
    submitBtn     = modal.querySelector('[data-atc-btn]');
    hint          = modal.querySelector('.pricing-form-hint');
    errorEl       = modal.querySelector('.service-modal-error');
    introEl       = document.getElementById('smIntro');
    purposeSelect = document.getElementById('smPurpose');
    existingUrlField  = document.getElementById('smExistingUrlField');
    existingUrlInput  = document.getElementById('smExistingUrl');

    if (form) {
      form.addEventListener('input',  updateSubmitState);
      form.addEventListener('change', updateSubmitState);
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (currentMode === 'quote') submitQuote(); else submitToCart();
      });
    }

    if (purposeSelect) purposeSelect.addEventListener('change', toggleUrlField);

    /* open trigger */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-open-service-modal]');
      if (!btn || btn.disabled) return;
      var mode = btn.getAttribute('data-mode') || '';
      openModal(
        btn.getAttribute('data-tier')  || '',
        btn.getAttribute('data-price') || '',
        btn.getAttribute('data-variant') || '',
        mode === 'quote' ? 'quote' : 'cart'
      );
      animateModalIn();
    });

    /* close triggers */
    modal.addEventListener('click', function (e) { if (e.target.closest('[data-modal-close]')) closeModal(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal(); });

    updateSubmitState();
  });
})();
